export default __webpack_public_path__ + "static/media/legend-mobile-nl.a59cd305.svg";